import React from 'react';
import './About.css'
import myImage from '../../../../images/asad-julhas2.png'

const About = () => {
  return (
    <div className='about_page'>
      <div className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <div className="about_me_area">
              <div className="row align-items-center">
              <div className="col-md-4">
           <div className="image_area">
           <img className='img-fluid' src={myImage} alt="Asadujjaman Julhas" title='Asadujjaman Julhas' />
           </div>
          </div>
          <div className="col-md-8">
           <div className="my_goal">
           <h3>Asadujjaman Julhas</h3>
           <p>I want to be a web developer, this is my mission for 2022. I already started working for my mission. From the first day of the year, I will continue hard work for at least 6 months. I will give 6-7 hours in a day for my web developer career, hope I will achieve my goal.</p>
           </div>
          </div>

              </div>
            </div>
           </div>
          </div>
         
        </div>
      </div>
  );
};

export default About;